import { render, staticRenderFns } from "./ReportMain.vue?vue&type=template&id=06dbcec6"
import script from "./ReportMain.vue?vue&type=script&lang=js"
export * from "./ReportMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dbcec6')) {
      api.createRecord('06dbcec6', component.options)
    } else {
      api.reload('06dbcec6', component.options)
    }
    module.hot.accept("./ReportMain.vue?vue&type=template&id=06dbcec6", function () {
      api.rerender('06dbcec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/ReportMain.vue"
export default component.exports